import { render, staticRenderFns } from "./LevelCalibrationTable.vue?vue&type=template&id=2bb5375e"
import script from "./LevelCalibrationTable.vue?vue&type=script&lang=js"
export * from "./LevelCalibrationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports